





































































import { defineComponent } from "@vue/composition-api";
import { getStereoFormat, isAudioFile, isImageFile, isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseBadge from "@/components/BaseBadge";
import BaseButton from "@/components/BaseButton";
import BaseChip from "@/components/BaseChip";
import BaseCloser from "@/components/BaseCloser";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import FileImageView from "./components/FileImageView";
import MediaImageView from "./components/MediaImageView";
import PreviewSetButton from "../PreviewSetButton";

export default defineComponent({
  name: "PostFileItemPreview",
  components: {
    BaseBadge,
    BaseChip,
    PreviewSetButton,
    LoadingThumbnail,
    BaseCloser,
    BaseIcon,
    BaseButton,
    MediaImageView,
    FileImageView,
  },
  props: {
    postFile: { type: Object as () => PostFileData, required: true },
    removable: { type: Boolean, default: true },
    showPublicButton: { type: Boolean, default: false },
    draggableClass: { type: String, default: "" },
    hideInfo: { type: Boolean, default: false },
  },
  computed: {
    processingError(): boolean {
      return this.postFile.processingStatus === "ERROR";
    },
    isPublic(): boolean {
      return this.postFile.public;
    },
    icon(): string {
      if (isVideoFile(this.postFile)) return "sci-video";
      if (isImageFile(this.postFile)) return "sci-image";
      if (isAudioFile(this.postFile)) return "sci-music-note";
      return "sci-file-outline";
    },
    src(): string {
      if (!this.postFile.url) return "";
      if (isVideoFile(this.postFile)) return MediaFilesController.getVideoThumbnail(this.postFile.url, "480p");
      if (isImageFile(this.postFile)) return MediaFilesController.getImageThumbnail(this.postFile.url, "480p");
      return "";
    },
    duration(): string {
      if (this.postFile.duration) return getMediaDuration(this.postFile.duration);
      return "";
    },
    isMedia(): boolean {
      return isMediaFile(this.postFile);
    },
    stereoFormat(): string {
      return getStereoFormat(this.postFile);
    },
    fileName(): string {
      return this.postFile.metadata?.filename || this.postFile.fileName;
    },
  },
});
